export default __webpack_public_path__ + "static/media/hero-image.35f02b81.png";